import { useMemo } from 'react';
import EntityTable from './EntityTable';
import Button from './ui/Button';
import ImagePreview from './ui/ImagePreview';
import { setProjectHomeCover, reorderHomeCarousel } from '../../services/adminApi';

const carouselColumns = [
  { key: 'cover', label: '', render: (row) => <ImagePreview src={row.homeCoverImage} size={40} /> },
  { key: 'nom', label: 'Projet', render: (row) => row.nom?.fr || row.nom?.en }
];

function AdminCarouselTab({ projects, reload, showToast }) {
  const featured = useMemo(
    () =>
      projects
        .filter((p) => p.homeCarouselPosition != null)
        .sort((a, b) => a.homeCarouselPosition - b.homeCarouselPosition),
    [projects]
  );

  const handleSelect = async (project, imagePath) => {
    const next = project.homeCoverImage === imagePath ? '' : imagePath;
    await setProjectHomeCover(project.id, next);
    await reload();
  };

  const handleReorder = async (ids) => {
    await reorderHomeCarousel(ids);
    await reload();
  };

  const handleRemove = async (project) => {
    await setProjectHomeCover(project.id, '');
    await reload();
    showToast('Retiré du carrousel.');
  };

  return (
    <div className="admin-carousel-tab">
      <section>
        <h3>Ordre du carrousel</h3>
        <div className="admin-carousel-order">
          <EntityTable
            columns={carouselColumns}
            rows={featured}
            onReorder={handleReorder}
            renderExtraActions={(row) => (
              <Button variant="danger" onClick={() => handleRemove(row)}>
                Retirer
              </Button>
            )}
            emptyMessage="Aucun projet sélectionné pour le moment."
          />
        </div>
      </section>

      <section>
        <h3>Sélection</h3>
        <p className="admin-field-hint">
          Une image par projet, au choix. Cliquer une image sélectionnée la retire du carrousel.
        </p>
        <div className="admin-carousel-selection">
          {projects.map((project) => (
            <div key={project.id} className="admin-carousel-selection-row">
              <div className="admin-carousel-selection-name">{project.nom?.fr || project.nom?.en}</div>
              {project.images.length === 0 ? (
                <p className="admin-field-hint">Aucune image sur ce projet.</p>
              ) : (
                <div className="admin-cover-picker">
                  {project.images.map((src, index) => (
                    <button
                      type="button"
                      key={`${src}-${index}`}
                      className={`admin-cover-picker-item${project.homeCoverImage === src ? ' selected' : ''}`}
                      onClick={() => handleSelect(project, src)}
                      title={project.homeCoverImage === src ? 'Retirer du carrousel' : 'Définir comme couverture'}
                    >
                      <ImagePreview src={src} size={56} />
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default AdminCarouselTab;
